// hooks/useTagIcon.js
import { useGetTagIconsQuery } from "store/api";
import useQueryLoader from "./useQueryLoader";

const NO_ICONS = [];

/** Tag icons, requested once and cached by RTK Query. */
const useTagIcon = () => {
  const { data, isFetching } = useGetTagIconsQuery();
  useQueryLoader(isFetching);

  return {
    loader: isFetching,
    tagIconData: data ?? NO_ICONS,
  };
};

export default useTagIcon;
